export default "__VITE_ASSET__3fa1f545__"